function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useCallback, useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import useCookieStore from '../../hooks/useCookieStore';
import Accordion from '../Accordion';
import AccordionItemVariant from '../Accordion/AccordionItemVariant';
import Button from '../Button';
import Container from '../Layout/Container';
import Checkbox from './Checkbox';
import { LocalConsentStatus, AvailableConsentPermissions } from './types';
import './style.scss';
export var COOKIE_CONSENT_CATEGORIES = 'cookie_consent_categories';
export var COOKIE_CONSENT_STATE = 'cookie_consent_state';
export var DEFAULT_COOKIE_EXPIRATION_DAYS = 365;
export var CONSENT_UPDATE_EVENT = 'consentUpdate';
var categoryDefaultValues = {
  necessary: true,
  preferences: false,
  statistics: false,
  marketing: false
};
var CookieCompliancePopup = function CookieCompliancePopup(props) {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var className = props.className,
    children = props.children,
    _props$title = props.title,
    title = _props$title === void 0 ? t('cookies.title') : _props$title,
    _props$manualText = props.manualText,
    manualText = _props$manualText === void 0 ? t('cookies.manual') : _props$manualText,
    _props$acceptAllText = props.acceptAllText,
    acceptAllText = _props$acceptAllText === void 0 ? t('cookies.acceptAll') : _props$acceptAllText,
    _props$acceptSelectio = props.acceptSelectionText,
    acceptSelectionText = _props$acceptSelectio === void 0 ? t('cookies.acceptSelection') : _props$acceptSelectio,
    _props$acceptAllSelec = props.acceptAllSelectionsText,
    acceptAllSelectionsText = _props$acceptAllSelec === void 0 ? t(['cookies.acceptAllSelections', 'cookies.acceptAll']) : _props$acceptAllSelec,
    _props$onlyNecessaryT = props.onlyNecessaryText,
    onlyNecessaryText = _props$onlyNecessaryT === void 0 ? t('cookies.acceptOnlyNecessary') : _props$onlyNecessaryT,
    _props$cookieContents = props.cookieContentsShowMore,
    cookieContentsShowMore = _props$cookieContents === void 0 ? /*#__PURE__*/React.createElement("div", null, t('cookies.showDetails')) : _props$cookieContents,
    _props$cookieContents2 = props.cookieContentsShowLess,
    cookieContentsShowLess = _props$cookieContents2 === void 0 ? /*#__PURE__*/React.createElement("div", null, t('cookies.hideDetails')) : _props$cookieContents2,
    _props$showAcceptOnly = props.showAcceptOnlyNeeded,
    showAcceptOnlyNeeded = _props$showAcceptOnly === void 0 ? true : _props$showAcceptOnly,
    _props$showAcceptOnly2 = props.showAcceptOnlyNeededSelections,
    showAcceptOnlyNeededSelections = _props$showAcceptOnly2 === void 0 ? false : _props$showAcceptOnly2,
    _props$onAgree = props.onAgree,
    onAgree = _props$onAgree === void 0 ? function () {} : _props$onAgree,
    _props$cookieLevels = props.cookieLevels,
    cookieLevels = _props$cookieLevels === void 0 ? [{
      value: 'necessary',
      label: t('cookies.categories.necessary.label'),
      subLabel: t('cookies.categories.necessary.subLabel'),
      description: t('cookies.categories.necessary.description'),
      disabled: true,
      consentOptions: ['security_storage']
    }, {
      value: 'preferences',
      label: t('cookies.categories.preferences.label'),
      description: t('cookies.categories.preferences.description'),
      disabled: false,
      consentOptions: ['functionality_storage', 'personalization_storage']
    }, {
      value: 'statistics',
      label: t('cookies.categories.statistics.label'),
      description: t('cookies.categories.statistics.description'),
      disabled: false,
      consentOptions: ['analytics_storage']
    }, {
      value: 'marketing',
      label: t('cookies.categories.marketing.label'),
      description: t('cookies.categories.marketing.description'),
      disabled: false,
      consentOptions: ['ad_personalization', 'ad_user_data', 'ad_storage']
    }] : _props$cookieLevels,
    _props$cookieOptions = props.cookieOptions,
    cookieOptions = _props$cookieOptions === void 0 ? {
      days: DEFAULT_COOKIE_EXPIRATION_DAYS,
      path: '/'
    } : _props$cookieOptions,
    _props$version = props.version,
    version = _props$version === void 0 ? '1.0.0' : _props$version,
    _props$cookieDomain = props.cookieDomain,
    cookieDomain = _props$cookieDomain === void 0 ? null : _props$cookieDomain,
    _props$defaultValues = props.defaultValues,
    defaultValues = _props$defaultValues === void 0 ? categoryDefaultValues : _props$defaultValues,
    _props$manualHeader = props.manualHeader,
    manualHeader = _props$manualHeader === void 0 ? '' : _props$manualHeader,
    _props$manualButtonCl = props.manualButtonClassname,
    manualButtonClassname = _props$manualButtonCl === void 0 ? 'Button' : _props$manualButtonCl,
    _props$necessaryButto = props.necessaryButtonInverted,
    necessaryButtonInverted = _props$necessaryButto === void 0 ? true : _props$necessaryButto;
  if (!window.dataLayer) {
    window.dataLayer = window.dataLayer || [];
  }
  if (!window.gtag) {
    // eslint-disable-next-line prefer-rest-params
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
  }

  // This is an internal state to check whether we should show the options.
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    manualChoiceVisible = _useState2[0],
    setManualChoiceVisible = _useState2[1];
  // This is an internal state to check whether the user has answered in the current session.
  // It is either null (because we don't know if it was already in the cookies) or true
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    answeredInCurrentSession = _useState4[0],
    setAnsweredInCurrentSession = _useState4[1];

  // Cookie stating if the cookie has already been accepted. Uses the following states:
  // null: unknown
  // STATUS DECLINED (0 as cookie value)
  // STATUS NOT YET ANSWERED (1 as cookie value)
  // STATUS ACCEPTED_ALL (2 as cookie value)
  var _useCookieStore = useCookieStore(COOKIE_CONSENT_STATE, JSON.stringify({
      status: LocalConsentStatus.STATUS_DEFAULT,
      version: version
    })),
    _useCookieStore2 = _slicedToArray(_useCookieStore, 2),
    didConsent = _useCookieStore2[0],
    setDidConsent = _useCookieStore2[1];
  var categories = cookieLevels.map(function (item) {
    return item.value;
  });
  var defaultState = categories.reduce(function (prev, category) {
    var existingConsent = getPreviouslyAcceptedCookieLevels(defaultValues);
    if (existingConsent) {
      return existingConsent;
    }
    var newPartialState = prev;
    if (defaultValues[category] !== undefined) {
      newPartialState[category] = defaultValues[category];
    } else {
      newPartialState[category] = true;
    }
    return newPartialState;
  }, {});

  // Default choices for select, this way we can locally manage the state of the form.
  var _useState5 = useState(defaultState),
    _useState6 = _slicedToArray(_useState5, 2),
    choicesSelected = _useState6[0],
    setChoicesSelected = _useState6[1];
  var isLoading = didConsent === undefined;
  var didConsentContent = typeof didConsent === 'string' && didConsent.length > 0 ? JSON.parse(didConsent) : null;
  useEffect(function () {
    // We now know the value of the cookie. If there is no cookie set,
    // immediately set the didConsent state to STATUS_NOT_YET_ANSWERED.
    if ((didConsentContent === null || didConsentContent === void 0 ? void 0 : didConsentContent.status) === LocalConsentStatus.STATUS_DEFAULT
    // For backwards compatibility
    || didConsent === LocalConsentStatus.STATUS_DEFAULT) {
      setDidConsent(JSON.stringify({
        status: LocalConsentStatus.STATUS_NOT_YET_ANSWERED,
        version: version
      }), cookieOptions);
    }
  }, [didConsentContent, cookieOptions, setDidConsent, version]);
  var isPrompting = (didConsentContent === null || didConsentContent === void 0 ? void 0 : didConsentContent.status) === LocalConsentStatus.STATUS_NOT_YET_ANSWERED;
  var isAnswered = (didConsentContent === null || didConsentContent === void 0 ? void 0 : didConsentContent.status) === LocalConsentStatus.STATUS_ACCEPTED || (didConsentContent === null || didConsentContent === void 0 ? void 0 : didConsentContent.status) === LocalConsentStatus.STATUS_ONLY_NECESSARY;
  var isEditing = (didConsentContent === null || didConsentContent === void 0 ? void 0 : didConsentContent.status) === LocalConsentStatus.STATUS_EDITING;
  useEffect(function () {
    if (isEditing) {
      setManualChoiceVisible(true);
    }
  }, [didConsent, setManualChoiceVisible, isEditing]);

  // This function expands the notification to show the options.
  var displayConsentChoices = function displayConsentChoices(e) {
    e.preventDefault();
    setManualChoiceVisible(true);
  };

  // On agree clicked, send consent for categories to Google
  // Update cookie and fire agree callback
  var onInternalAgree = useCallback(function (choices) {
    // Build an object of passed consent, send that to google via "update"
    // Set the cookie containing the consent categories and version
    var handleGoogleConsent = function handleGoogleConsent() {
      var selectedConsent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var selectedCategories = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var consentEventObject = {};
      Object.values(AvailableConsentPermissions).forEach(function (consentOption) {
        consentEventObject[consentOption] = selectedConsent.indexOf(consentOption) > -1 ? 'granted' : 'denied';
      });
      window.gtag('consent', 'update', consentEventObject);
      window.gtag('event', CONSENT_UPDATE_EVENT);
      Cookies.set(COOKIE_CONSENT_CATEGORIES, JSON.stringify({
        categories: selectedCategories,
        consent: consentEventObject
      }), {
        expires: cookieOptions.days,
        domain: cookieDomain
      });
      setDidConsent(JSON.stringify({
        status: LocalConsentStatus.STATUS_ACCEPTED,
        version: version
      }), cookieOptions);
      setAnsweredInCurrentSession(true);
    };
    var selectedCategories = Object.keys(choices).filter(function (key) {
      return choices[key];
    });
    var selectedConsent = [];
    cookieLevels.forEach(function (cookieLevel) {
      if (selectedCategories.indexOf(cookieLevel.value) > -1) {
        selectedConsent = selectedConsent.concat(cookieLevel.consentOptions);
      }
    });
    handleGoogleConsent(selectedConsent, selectedCategories);
    onAgree({
      selectedCategories: selectedCategories,
      consent: selectedConsent
    });
  }, [cookieDomain, cookieLevels, cookieOptions, onAgree, setDidConsent, version]);

  // Function for accepting al categories at once.
  var onConsentAll = useCallback(function () {
    var allCategoriesSelected = categories.reduce(function (prev, category) {
      var newPartialState = prev;
      newPartialState[category] = true;
      return newPartialState;
    }, {});
    setChoicesSelected(allCategoriesSelected);
    onInternalAgree(allCategoriesSelected);
  }, [categories, onInternalAgree]);
  var onConsentOnlyNecessary = useCallback(function () {
    setChoicesSelected(defaultValues);
    onInternalAgree(defaultValues);
  }, [defaultValues, onInternalAgree]);

  // This function is fired when the accept button is pressed.
  // Also has eventual support for a false case.
  var onConsent = useCallback(function () {
    onInternalAgree(choicesSelected);
  }, [choicesSelected, onInternalAgree]);

  // This function sets the value of the checkmark in the form state.
  var handleChoiceState = function handleChoiceState(event) {
    var _ref = event.target,
      value = _ref.value,
      checked = _ref.checked;
    setChoicesSelected(_objectSpread(_objectSpread({}, choicesSelected), {}, _defineProperty({}, value, checked)));
  };
  var classes = classNames('GoogleConsentCookieBanner', className, {
    'GoogleConsentCookieBanner--prompting': isPrompting,
    'GoogleConsentCookieBanner--loading': isLoading,
    'GoogleConsentCookieBanner--answered': isAnswered,
    // answering refers to the fact that the user has answered in the current session.
    'GoogleConsentCookieBanner--answering': answeredInCurrentSession,
    'GoogleConsentCookieBanner--hidden': isAnswered,
    'GoogleConsentCookieBanner--editing': isEditing
  });

  // This function renders the different options of checkboxes,
  // allowing us to add more checkboxes eventually.
  var renderChoices = function renderChoices() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, cookieLevels.map(function (choice) {
      return /*#__PURE__*/React.createElement("div", {
        className: "GoogleConsentCookieBanner__category",
        key: choice.value
      }, /*#__PURE__*/React.createElement("div", {
        className: "CheckboxContainer"
      }, /*#__PURE__*/React.createElement(Checkbox, {
        name: "cookie-categories",
        id: "cookie-category-".concat(choice.value),
        onChange: handleChoiceState,
        label: choice.label,
        subLabel: choice.subLabel,
        value: choice.value,
        checked: choicesSelected[choice.value],
        disabled: choice.disabled
      })), /*#__PURE__*/React.createElement("div", {
        className: "GoogleConsentCookieBanner__category__description"
      }, choice.description), choice.contents && typeof choice.contents === 'function' && /*#__PURE__*/React.createElement(Accordion, null, /*#__PURE__*/React.createElement(AccordionItemVariant, {
        title: "",
        buttonOpened: cookieContentsShowLess,
        buttonClosed: cookieContentsShowMore,
        onClick: function onClick() {}
      }, /*#__PURE__*/React.createElement("div", {
        className: "GoogleConsentCookieBanner__category__description"
      }, choice.contents()))));
    }));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes,
    role: "region",
    "aria-label": t('cookies.banner_label')
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("div", {
    className: "GoogleConsentCookieBanner__content ".concat(manualChoiceVisible ? 'GoogleConsentCookieBanner__content--full-height' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 GoogleConsentCookieBanner__content_header"
  }, title && /*#__PURE__*/React.createElement("h3", null, title))), !manualChoiceVisible ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 GoogleConsentCookieBanner__content__message"
  }, children), /*#__PURE__*/React.createElement("div", {
    className: "col-12 GoogleConsentCookieBanner__content__buttons"
  }, /*#__PURE__*/React.createElement(Button, {
    id: "complete-agree",
    className: "Button--cta",
    primary: true,
    onClick: onConsentAll
  }, acceptAllText), showAcceptOnlyNeeded && /*#__PURE__*/React.createElement(Button, {
    id: "only-necessary-agree",
    className: "Button--cta",
    inverted: necessaryButtonInverted,
    onClick: onConsentOnlyNecessary
  }, onlyNecessaryText), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "GoogleConsentCookieBanner__content__buttons__manual GoogleConsentCookieBanner__content__buttons__manual-agree ".concat(manualButtonClassname),
    onClick: function onClick(e) {
      displayConsentChoices(e);
    }
  }, manualText)))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "GoogleConsentCookieBanner__content__message"
  }, /*#__PURE__*/React.createElement("div", {
    className: "GoogleConsentCookieBanner__checkboxes-container"
  }, manualHeader && /*#__PURE__*/React.createElement("div", {
    className: "manualHeader"
  }, manualHeader), renderChoices())), /*#__PURE__*/React.createElement("div", {
    className: "GoogleConsentCookieBanner__content__buttons"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "Button--cta",
    primary: true,
    onClick: onConsent
  }, acceptSelectionText), showAcceptOnlyNeededSelections && /*#__PURE__*/React.createElement(Button, {
    id: "only-necessary-agree-selections",
    className: "Button--cta",
    inverted: necessaryButtonInverted,
    onClick: onConsentOnlyNecessary
  }, onlyNecessaryText), /*#__PURE__*/React.createElement(Button, {
    className: "Button--cta",
    inverted: necessaryButtonInverted,
    onClick: onConsentAll
  }, acceptAllSelectionsText))))));
};

/**
 * Get the previously accepted cookie levels from the cookie if the user has previously
 * given consent to the use of cookies.
 *
 * @param defaultValues The default values for the cookie categories. Keys that are
 * retrieved from the cookie that are not present in defaultValues will be omitted.
 */
function getPreviouslyAcceptedCookieLevels(defaultValues) {
  var cookies = Cookies.get(COOKIE_CONSENT_CATEGORIES);
  if (!cookies) {
    return null;
  }
  try {
    var parsedCookies = JSON.parse(cookies);
    if (!('categories' in parsedCookies)) {
      return null;
    }
    var result = _objectSpread({}, defaultValues);
    parsedCookies.categories.forEach(function (category) {
      if (defaultValues[category] !== undefined) {
        result[category] = true;
      }
    });
    return result;
  } catch (error) {
    return null;
  }
}
export default CookieCompliancePopup;